// extracted by mini-css-extract-plugin
module.exports = {"borderBottomTransparent":"styles-module__borderBottomTransparent___2rNJ5","borderBottomDarkPrimary":"styles-module__borderBottomDarkPrimary___1WOxr"};